import * as types from "../../constants/misc/settings_constant";
import createAsyncAction from "../../../utils/async_action_utils";
import * as api from "../../api/misc/manual_authorization_api";

const addManualAuthorizationTypes = {
  success: types.ADD_MANUAL_AUTHORIZATION_SUCCESS,
  failure: types.ADD_MANUAL_AUTHORIZATION_FAILURE,
};

const getManualAuthorizationTypes = {
  success: types.GET_MANUAL_AUTHORIZATION_SUCCESS,
  failure: types.GET_MANUAL_AUTHORIZATION_FAILURE,
};

const deleteManualAuthorizationTypes = {
  success: types.DELETE_MANUAL_AUTHORIZATION_SUCCESS,
  failure: types.DELETE_MANUAL_AUTHORIZATION_FAILURE,
};

export const addManualAuthorization = (formData) => async (dispatch) => {
  try {
    const response = await api.addManualAuthorizationApi(formData);
    const { error, data } = response;

    if (error) {
      dispatch({ type: addManualAuthorizationTypes.failure, payload: error });
    } else {
      dispatch({ type: addManualAuthorizationTypes.success, payload: data });
      window.location.reload();
    }
  } catch (error) {
    dispatch({ type: addManualAuthorizationTypes.failure, payload: error });
  }
};

export const getManualAuthorization = createAsyncAction(
  api.getManualAuthorizationApi,
  getManualAuthorizationTypes
);

export const deleteManualAuthorization = createAsyncAction(
  api.deleteManualAuthorizationApi,
  deleteManualAuthorizationTypes
);
